"use client";
import { Dialog } from "@base-ui/react";
import { X } from "lucide-react";
import { Button } from "../ui/button";

const SecurityIcon = () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>security icon</title>
    <path
      d="M10.4901 2.22957L5.50015 4.09957C4.35015 4.52957 3.41016 5.88955 3.41016 7.11955V14.5495C3.41016 15.7295 4.19017 17.2795 5.14017 17.9895L9.44016 21.1996C10.8502 22.2596 13.1701 22.2596 14.5801 21.1996L18.8802 17.9895C19.8302 17.2795 20.6101 15.7295 20.6101 14.5495V7.11955C20.6101 5.88955 19.6701 4.52957 18.5201 4.09957L13.5302 2.22957C12.6802 1.91957 11.3201 1.91957 10.4901 2.22957Z"
      stroke="#0091D5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M11.9997 10.9194C11.9597 10.9194 11.9097 10.9194 11.8697 10.9194C10.9297 10.8894 10.1797 10.1094 10.1797 9.15942C10.1797 8.18942 10.9697 7.39941 11.9397 7.39941C12.9097 7.39941 13.6997 8.18942 13.6997 9.15942C13.6897 10.1194 12.9397 10.8894 11.9997 10.9194Z"
      stroke="#0091D5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M10.0091 13.7204C9.04906 14.3604 9.04906 15.4103 10.0091 16.0503C11.0991 16.7803 12.8891 16.7803 13.9791 16.0503C14.9391 15.4103 14.9391 14.3604 13.9791 13.7204C12.8991 12.9904 11.1091 12.9904 10.0091 13.7204Z"
      stroke="#0091D5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

const rules = [
  {
    description:
      "Her anne-baba farklı bir yolculukta. Kimseyi yargılamadan, kırmadan, incitmeden yorum yapın.",
    icon: "🤝",
    title: "Saygılı ve nazik olun.",
  },
  {
    description:
      "Tıbbi teşhis, tedavi önerisi, ilaç yönlendirmesi yapmak yerine genel deneyim paylaşabilirsiniz. Uzman görüşü gerektiren durumlarda kullanıcıları hekime yönlendirin.",
    icon: "🩺",
    title: "Kişisel sağlık teşhisi koymayın.",
  },
  {
    description:
      "Bilimsel dayanağı olmayan uygulamalar, yanlış bilgiler veya kulaktan dolma sağlık iddiaları paylaşmayın.",
    icon: "⚠️",
    title: "Bilgi kirliliği yaratacak içeriklerden kaçının.",
  },
  {
    description:
      "Telefon numarası, adres, e-posta, sosyal medya hesabı gibi bilgiler güvenliğiniz için paylaşılmamalıdır.",
    icon: "🔒",
    title: "Kişisel bilgilerinizi paylaşmayın.",
  },
];

const RuleDialog = () => {
  return (
    <Dialog.Root>
      <Dialog.Trigger
        render={
          <Button
            className="text-brand-blue-500 hover:text-brand-blue-700"
            variant="ghost"
          />
        }
      >
        <SecurityIcon />
        Kurallar
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Backdrop className="fixed inset-0 bg-black/40 backdrop-blur-sm transition-all duration-200 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0" />
        <Dialog.Popup className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-lg bg-white rounded-2xl shadow-xl outline-none transition-all duration-200 data-[ending-style]:scale-95 data-[ending-style]:opacity-0 data-[starting-style]:scale-95 data-[starting-style]:opacity-0 max-h-[90dvh] flex flex-col mx-4">
          <div className="flex items-center justify-between p-5 border-b border-gray-100">
            <div className="flex items-center gap-2">
              <SecurityIcon />
              <Dialog.Title className="text-lg font-bold text-gray-900">
                Topluluk Kuralları
              </Dialog.Title>
            </div>
            <Dialog.Close className="flex items-center justify-center size-8 rounded-full hover:bg-gray-100 transition-colors cursor-pointer text-gray-500 hover:text-gray-700">
              <X size={18} />
            </Dialog.Close>
          </div>

          <div className="overflow-y-auto p-5 flex flex-col gap-4">
            <Dialog.Description className="text-sm text-gray-500 leading-relaxed">
              Topluluğumuzun güvenli, destekleyici ve saygılı kalması için
              lütfen aşağıdaki kurallara dikkat edin.
            </Dialog.Description>

            <ul className="flex flex-col gap-3">
              {rules.map((rule) => (
                <li
                  className="flex gap-3 p-3.5 rounded-xl bg-gray-50 border border-gray-100"
                  key={rule.title}
                >
                  <span className="text-2xl shrink-0 leading-none mt-0.5">
                    {rule.icon}
                  </span>
                  <div className="flex flex-col gap-0.5">
                    <span className="text-sm font-semibold text-gray-800">
                      {rule.title}
                    </span>
                    <span className="text-sm text-gray-500 leading-relaxed">
                      {rule.description}
                    </span>
                  </div>
                </li>
              ))}
            </ul>

            <p className="text-xs text-gray-400 text-center pb-1">
              Kurallara uymayan yorumlar moderatörlerimiz tarafından
              kaldırılabilir.
            </p>
          </div>

          <div className="p-4 border-t border-gray-100">
            <Dialog.Close
              render={
                <Button className="w-full" />
              }
            >
              Anladım
            </Dialog.Close>
          </div>
        </Dialog.Popup>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default RuleDialog;
